import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { tagsApi } from '../lib/api';

// Etichetta (tag) come restituita dall'API
export interface Tag {
  id: string;
  name: string;
  color: string;
  icon: string | null;
  parent_id: string | null;
  is_ai_managed: boolean;
}

export function useTags() {
  return useQuery({
    queryKey: ['tags'],
    // Lista piccola ed economica: niente cache "stale" così un tag appena
    // creato compare subito tra quelli selezionabili in tutte le viste.
    staleTime: 0,
    refetchOnMount: 'always',
    queryFn: async () => {
      const res = await tagsApi.list();
      return (res?.tags ?? res ?? []) as Tag[];
    },
  });
}

export function useCreateTag() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: {
      name: string;
      color: string;
      icon?: string | null;
      parent_id?: string | null;
      is_ai_managed?: boolean;
    }) => tagsApi.create(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['tags'] }),
  });
}

export function useUpdateTag() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: Partial<Omit<Tag, 'id'>> }) =>
      tagsApi.update(id, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['tags'] }),
  });
}

export function useDeleteTag() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => tagsApi.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['tags'] }),
  });
}
